import { Component, Input } from "@angular/core";
import { SelectEvent } from "@progress/kendo-angular-layout";
import { Subscription } from "rxjs";
import { KeyValue } from "src/app/framework/domain-entity/key-value";
import { pageLifeCycleNotifier } from "src/app/models/new-product/notifier/page-life-cycle-notifier";
import { MortgageFireHKTabSchema } from "src/app/models/new-product/sme/mortgage-fire/hong-kong/base/schemas/mf-hk-tab-schema";
import { MortgageFireHongKongProposal } from "src/app/models/new-product/sme/mortgage-fire/hong-kong/base/mf-hk-proposal";
import { MfHkBaseComponent } from "../mf-hk-base.component";
import { MfHkTabchangeService } from "src/app/services/new-product/sme/mortgage-fire/hong-kong/mf-hk-tabchange.service";
import * as EnumHK from "src/app/models/new-product/sme/mortgage-fire/hong-kong/base/mf-hk-enums";

export class TabModel {
  constructor(
    public index: number,
    public displayName: string,
    public visible: boolean
  ) {}
}

@Component({
    selector: "mf-hk-tabs",
    templateUrl: "./mf-hk-tabs.component.html",
    styleUrls: ["./mf-hk-tabs.component.scss"],
    standalone: false
})
export class MfHkTabsComponent extends MfHkBaseComponent {
  constructor(private mfHkTabchangeService: MfHkTabchangeService) {
    super();
  }
  pageLoaded: boolean = false;

  master!: TabModel;
  locations!: TabModel;
  businessInterruption!: TabModel;
  premiumSummary!: TabModel;
  clausesAndDeductibles!: TabModel;
  money!: TabModel;
  //     tabStrip: kendo.ui.TabStrip;
  tab_request_notifier_subscriptions!: Subscription;

  @Input() proposal!: MortgageFireHongKongProposal; //temp using @Input()

  override ngOnInit(): void {
    this.initialize();

    this.tab_request_notifier_subscriptions =
      pageLifeCycleNotifier.tab_request_notifier$.subscribe(
        this.tabRequestNotifier
      );
  }

  ngOnDestroy() {
    this.unsubscribeAllRxjs();
  }

  private initialize() {
    this.pageLoaded = true;
    super.subscribePageLoadedNotifier(this.pageLoadedNotifier);
    super.subscribeProposalLoadedNotifier(this.pageLoadedNotifier);

    this.master = new TabModel(
      MortgageFireHKTabSchema.master.index,
      MortgageFireHKTabSchema.master.displayText,
      true
    );

    this.locations = new TabModel(
      MortgageFireHKTabSchema.locations.index,
      MortgageFireHKTabSchema.locations.displayText,
      true
    );

    this.premiumSummary = new TabModel(
      MortgageFireHKTabSchema.premiumSummary.index,
      MortgageFireHKTabSchema.premiumSummary.displayText,
      true
    );

    this.businessInterruption = new TabModel(
      MortgageFireHKTabSchema.businessInterruption.index,
      MortgageFireHKTabSchema.businessInterruption.displayText,
      true
    );

    this.money = new TabModel(
      MortgageFireHKTabSchema.money.index,
      MortgageFireHKTabSchema.money.displayText,
      true
    );

    this.clausesAndDeductibles = new TabModel(
      MortgageFireHKTabSchema.clausesAndDeductibles.index,
      MortgageFireHKTabSchema.clausesAndDeductibles.displayText,
      this.proposal.productType === EnumHK.MortgageFireHKProduct.HSCMB
        ? true
        : false
    );
  }

  private tabRequestNotifier = (event: KeyValue<string>) => {
    const tabId = parseInt(event.key, 10);
    this.select(tabId);
    const element: any = document.getElementById(event.value);
    const offset = element.getBoundingClientRect().top - 100;
    window.scrollTo({ top: offset, left: 0, behavior: "smooth" });
  };

  /** Method to be invoke upon page loaded successfully */
  private pageLoadedNotifier = (response: any) => {
    let event = response as KeyValue<MortgageFireHongKongProposal>;
    this.proposal = event.value;
    this.pageLoaded = true;
    //this.tabStrip = $('#tabstrip').kendoTabStrip().data('kendoTabStrip');//todo: check if needed
    this.autoSelect();
  };

  unsubscribeAllRxjs() {
    super.unsubscribeRxjs();
    this.tab_request_notifier_subscriptions?.unsubscribe();
  }

  autoSelect() {
    switch (this.proposal.transType) {
      default: //this.onTabSelect(this.master.index);
        // default to master tab
        this.click(this.master.index);
        break;
    }
  }

  public onTabSelect(e: SelectEvent) {
    //this.tabStrip.select(tabIndex);//todo: check if needed
    this.click(e.index);
    this.mfHkTabchangeService.emitNumber(e.index);
  }

  click(tabIndex: number) {
    pageLifeCycleNotifier.tab_load_notifier$.next(
      new KeyValue<MortgageFireHongKongProposal>(
        tabIndex.toString(),
        this.proposal
      )
    );
  }

  select(tabIndex: number) {
    // this.tabStrip.selectTab(tabIndex);
    this.click(tabIndex);
  }
}
